import { DashboardAuthCallbackPage } from "@dashboard/components/auth-flow/AuthCallbackPage"
import { dashboardAppHostRedirectUrl } from "@dashboard-config/dashboard-host"
import { currentRequestHostname } from "@dashboard-config/dashboard-host-runtime"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/auth/callback")({
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })
  },
  component: DashboardAuthCallbackPage,
})
